import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	addTitle: {
		id: 'eoc-schedule.ui.list.add-override.add-title',
		defaultMessage: 'Override',
		description: 'Title for add override modal.',
	},
	editTitle: {
		id: 'eoc-schedule.ui.list.add-override.edit-title',
		defaultMessage: 'Edit Override',
		description: 'Title for edit override modal.',
	},
	customizeTitle: {
		id: 'eoc-schedule.ui.list.add-override.customize-title',
		defaultMessage: 'Override',
		description: 'Title for customize override modal.',
	},
	timezone: {
		id: 'eoc-schedule.ui.list.add-override.timezone',
		defaultMessage: 'Timezone',
		description: 'Label for override timezone.',
	},
	allRotations: {
		id: 'eoc-schedule.ui.list.add-override.all-rotations',
		defaultMessage: 'All Rotations',
		description: 'Placeholder when all rotations are selected for override.',
	},
	overrideShiftParticipantWith: {
		id: 'eoc-schedule.ui.list.add-override.override-shift-participant-with',
		defaultMessage: 'Override shift participant with',
		description: 'Label for field that indicates which participant is overriding.',
	},
	selectRotation: {
		id: 'eoc-schedule.ui.list.add-override.select-rotation',
		defaultMessage: 'Select rotation',
		description: 'Label for select a rotation field.',
	},
	override: {
		id: 'eoc-schedule.ui.list.add-override.override',
		defaultMessage: 'Override {label}',
		description: 'Prefix for labels. Ex. override start time, override end time.',
	},
});

export { messages };
